import { render, staticRenderFns } from "./SmsVerificationCode.vue?vue&type=template&id=09b6448e&scoped=true"
import script from "./SmsVerificationCode.vue?vue&type=script&lang=js"
export * from "./SmsVerificationCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b6448e",
  null
  
)

export default component.exports